import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LoadingState {
  loadingReportSelectGroup: boolean;
  loadingReportSelectCourse: boolean;
  loadingReportSelectSemester: boolean;
  loadingReportSelectOrganization: boolean;
  loadingReportSelectCurricularUnit: boolean;
}

const initialState: LoadingState = {
  loadingReportSelectGroup: false,
  loadingReportSelectCourse: false,
  loadingReportSelectSemester: false,
  loadingReportSelectOrganization: false,
  loadingReportSelectCurricularUnit: false,
};

export const LoadingSelectReportSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setLoadingReportSelectCourse: (state, action: PayloadAction<boolean>) => {
      state.loadingReportSelectCourse = action.payload;
    },
    setLoadingReportSelectSemester: (state, action: PayloadAction<boolean>) => {
      state.loadingReportSelectSemester = action.payload;
    },
    setLoadingReportSelectCurricularUnit: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.loadingReportSelectCurricularUnit = action.payload;
    },
    setLoadingReportSelectGroup: (state, action: PayloadAction<boolean>) => {
      state.loadingReportSelectGroup = action.payload;
    },
    setLoadingReportSelectOrganization: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.loadingReportSelectOrganization = action.payload;
    },
  },
});

export const {
  setLoadingReportSelectGroup,
  setLoadingReportSelectCourse,
  setLoadingReportSelectSemester,
  setLoadingReportSelectCurricularUnit,
  setLoadingReportSelectOrganization,
} = LoadingSelectReportSlice.actions;
export default LoadingSelectReportSlice.reducer;
